export const renderActivateStatus = (status: string) => {
  switch (status) {
    case 'INPROGRESS':
      return '진행중';
    case 'COMPLETED':
      return '개통 완료';
    case 'FAILED':
      return '막힘';
    case 'PENDING':
      return '진행전';
    case 'CANCELED':
      return '해지';
    default:
      return status;
  }
};
